
export const formAutoFillSpecialTitle = (): void => {
  const contactFormElement = document.querySelector('.js-contactForm') as HTMLElement

  if (!contactFormElement) {
    return
  }

  const specialTitle = contactFormElement.querySelector('.js-contactForm-specialTitle') as unknown as HTMLElement

  if (!specialTitle) {
    return
  }

  // @ts-ignore
  const specialTitleValue = window.kSystemContactFormSpecialMegaTitle

  if (!specialTitleValue) {
    return
  }

  specialTitle.innerHTML = specialTitleValue
}
